import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchCustomizedTripsDtlbannersec } from "../services/CustomizedTripsDtlbannersec";
import { API_BASE } from "../api/apiConfig";

const CustomizedTripsDtlsmillerlist = () => {
  const { id,type } = useParams();

  const [CustomizedTripsDtl, setCustomizedTripsDtl] = useState(null);
  const [similarTrips, setSimilarTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      const res = await fetchCustomizedTripsDtlbannersec(decodeURIComponent(id));

      if (res?.status) {
        // Main trip
        setCustomizedTripsDtl(res.data?.[0] || null);

        // Similar trips
        setSimilarTrips(res.tourexcursionslist || []);
      }

      setLoading(false);
    };

    loadData();
  }, [id]);

  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!CustomizedTripsDtl)
    return <p className="text-center py-10">No data found</p>;

  return (
    <>
     {/* Similar Trips */}
      <section className="mt-12 md:mt-16 -mx-4 md:-mx-6 lg:-mx-8 px-4 md:px-6 lg:px-8 py-8 md:py-12 bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-900 mb-3">
              Similar Trips You Might Like
            </h2>
            <p className="text-sm md:text-base text-slate-600">
              Explore more destinations
            </p>
          </div>
          <div className="grid sm:grid-cols-2 gap-4 md:gap-6">


        {similarTrips.map((trip) => (
          <div key={trip.id} className="group cursor-pointer rounded-2xl overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
            <div className="relative h-48 md:h-56 overflow-hidden">
              <img
                alt="{trip.name}"
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-cover group-hover:scale-110 transition-transform duration-500"
                style={{
                  position: "absolute",
                  height: "100%",
                  width: "100%",
                  inset: 0,
                  color: "transparent"
                }}
                src={`${API_BASE}/${trip.images}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
              <div className="absolute bottom-3 left-3 right-3">
                <h3 className="font-bold text-white text-lg md:text-xl mb-1">
                  {trip.name}
                </h3>
                <div className="flex items-center gap-2 text-sm text-white/90">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-clock h-4 w-4"
                  >
                    <circle cx={12} cy={12} r={10} />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                  <span>{trip.no_of_days} Days</span>
                </div>
              </div>
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center justify-between">
                <div>
                {Number(trip.charges) !== 0 && (
                  <p className="text-xs text-slate-500 mb-1">Starting from</p>
                )}
                  <p className="text-xl md:text-2xl font-bold text-teal-600">{Number(trip.charges) === 0 ? "Customised" : `₹${trip.charges}`}</p>
                </div>
            <a class="block" href={`/CustomizedTripsDtl/${type}/${trip.id}`}
            >
                <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium">
                  View Details
                </button>
            </a>
              </div>
            </div>
          </div>
        ))}

        </div>

          {/* View All Button */}
          <div className="text-center mt-6 md:mt-8">
            <a href="/customizedtrips">
              <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-9 rounded-md px-3 bg-teal-500 hover:bg-teal-600 text-white text-sm md:text-base">
                View All Customized Trips
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-arrow-right ml-2 h-4 w-4"
                >
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
                </svg>
              </button>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default CustomizedTripsDtlsmillerlist;
